import { sendAxiosRequest } from "@api/request.js";
import { shoppingCartStore } from "@stores/shopping_cart_store.js";
import { storeToRefs } from "pinia";
import {
  encriptar,
  desencriptar,
  encriptarCampo,
} from "@composables/use_encript.js";

async function toggleShoppingCartModal(data) {
  const myShoppingCartStore = shoppingCartStore();
  myShoppingCartStore.toggleShoppingCartModal();
}

async function validateProduct(data) {
  const url = `${import.meta.env.VITE_API_BASE_URL}/api/validate-product`;

  let token =
    desencriptar(localStorage.getItem(encriptarCampo("token"))) !== ""
      ? desencriptar(localStorage.getItem(encriptarCampo("token")))
      : null;

  const config = {
    method: "post",
    url: url,
    headers: {
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    data: data,
  };
  return await sendAxiosRequest(config);
}

async function processCart(data) {
  const url = `${import.meta.env.VITE_API_BASE_URL}/api/validate-stock`;

  let token =
    desencriptar(localStorage.getItem(encriptarCampo("token"))) !== ""
      ? desencriptar(localStorage.getItem(encriptarCampo("token")))
      : null;

  const config = {
    method: "post",
    url: url,
    headers: {
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    data: data,
  };
  return await sendAxiosRequest(config);
}

async function nuevaVenta(data) {
  const url = `${import.meta.env.VITE_API_BASE_URL}/api/nuevaVenta`;

  let token =
    desencriptar(localStorage.getItem(encriptarCampo("token"))) !== ""
      ? desencriptar(localStorage.getItem(encriptarCampo("token")))
      : null;

  const config = {
    method: "post",
    url: url,
    headers: {
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    data: data,
  };
  return await sendAxiosRequest(config);
}

async function actualizarVenta(data) {
  const url = `${import.meta.env.VITE_API_BASE_URL}/api/actualizarVenta`;

  let token =
    desencriptar(localStorage.getItem(encriptarCampo("token"))) !== ""
      ? desencriptar(localStorage.getItem(encriptarCampo("token")))
      : null;

  const config = {
    method: "post",
    url: url,
    headers: {
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    data: data,
  };
  return await sendAxiosRequest(config);
}

async function cancelarVenta(data) {
  const url = `${import.meta.env.VITE_API_BASE_URL}/api/cancelar-venta`;

  let token =
    desencriptar(localStorage.getItem(encriptarCampo("token"))) !== ""
      ? desencriptar(localStorage.getItem(encriptarCampo("token")))
      : null;

  const config = {
    method: "post",
    url: url,
    headers: {
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    data: data,
  };

  return await sendAxiosRequest(config);
}

async function cambiarMetodoPago(data) {
  const url = `${import.meta.env.VITE_API_BASE_URL}/api/cambiarMetodoPago`;

  let token =
    desencriptar(localStorage.getItem(encriptarCampo("token"))) !== ""
      ? desencriptar(localStorage.getItem(encriptarCampo("token")))
      : null;

  const config = {
    method: "post",
    url: url,
    headers: {
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    data: data,
  };

  return await sendAxiosRequest(config);
}

async function showPayButton(data) {
  const url = `${import.meta.env.VITE_API_BASE_URL}/api/pay-button`;

  let token =
    desencriptar(localStorage.getItem(encriptarCampo("token"))) !== ""
      ? desencriptar(localStorage.getItem(encriptarCampo("token")))
      : null;

  const config = {
    method: "post",
    url: url,
    headers: {
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
      "X-Custom-Header": "Codemakers",
    },
    data: {
      email: data.email,
      cartItems: data.cartItems,
      saleId: data.saleId,
    },
  };

  localStorage.setItem(encriptarCampo("saleId"), encriptar(data.saleId));

  const response = await sendAxiosRequest(config);

  document.getElementById("loadingText").innerHTML = "";
  let loadingSpinner = document.getElementById("loadingSpinner");
  if (loadingSpinner) {
    loadingSpinner.classList.remove("d-none");
  }
  document.getElementById("loading").classList.remove("d-none");
  //Modal
  document.getElementById("spinnerModal").classList.add("d-none");

  const mlScript = document.createElement("script");
  let preferenceId = response.data.preferenceId;

  mlScript.dataset.preferenceId = preferenceId;
  mlScript.src =
    "https://www.mercadopago.com.ar/integrations/v1/web-payment-checkout.js";

  document.querySelector("#payForm").append(mlScript);
  mlScript.addEventListener("load", (event) => {
    document.getElementById("spinnerModal").classList.add("d-none");
    document
      .getElementsByClassName("mercadopago-button")[0]
      .addEventListener("mousedown", (event) => {
        event.preventDefault;
        toggleShoppingCartModal();
        localStorage.setItem(
          encriptarCampo("basterShopingCart"),
          JSON.stringify(encriptar([]))
        );
        localStorage.setItem(encriptarCampo("preferenceId"), encriptar(""));
        localStorage.setItem(encriptarCampo("saleId"), encriptar(""));
        localStorage.setItem(
          encriptarCampo("cartModified"),
          encriptar("false")
        );
      });
  });
  return preferenceId;
}

export {
  processCart,
  validateProduct,
  nuevaVenta,
  actualizarVenta,
  showPayButton,
  cancelarVenta,
  cambiarMetodoPago,
};
